import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NbLayoutModule } from '@nebular/theme';

@Component({
  selector: 'app-layout-inscricao-publica',
  standalone: true,
  imports: [RouterOutlet, NbLayoutModule],
  templateUrl: './layout-inscricao-publica.component.html',
  styleUrl: './layout-inscricao-publica.component.scss',
})
export class LayoutInscricaoPublicaComponent {}
